import script from "./PopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopUp.vue?vue&type=script&setup=true&lang=ts"

import "./PopUp.vue?vue&type=style&index=0&id=ce108de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce108de2"]])

export default __exports__